document.addEventListener('click', (event) => {
  const dot = event.target.closest('[data-massaro-dot-index]');
  if (!dot) return;

  const card = dot.closest('.massaro-card__frame');
  if (!card) return;

  const index = dot.dataset.massaroDotIndex;

  card.querySelectorAll('[data-massaro-dot-index]').forEach((d) => {
    d.classList.toggle('is-active', d === dot);
  });

  card.querySelectorAll('[data-massaro-media-index]').forEach((img) => {
    img.classList.toggle('is-active', img.dataset.massaroMediaIndex === index);
  });
});
